enum EnumDemandStatus {
  ALL = 'Tous',
  EN_COURS = 'En cours',
  EN_ATTENTE_INFO_CLIENT = 'En attente info. client',
  TRAITEE = 'Traitée',
  ANNULE = 'Annulée',
  EN_COURS_DE_TRANSMISSION = 'En cours de transmission',
  PLANIFIE = 'Planifiée',
  ENVOYE = 'Envoyée',
}
export default EnumDemandStatus

export const IconsDemandStatus: Record<string, string> = {
  [EnumDemandStatus.ALL]: '',
  [EnumDemandStatus.EN_COURS]: 'dataTransferHorizontal',
  [EnumDemandStatus.EN_ATTENTE_INFO_CLIENT]: 'commonFileQuestion',
  [EnumDemandStatus.TRAITEE]: 'circleCheck',
  [EnumDemandStatus.ANNULE]: 'delete',
  [EnumDemandStatus.EN_COURS_DE_TRANSMISSION]: 'emailActionSyn',
  [EnumDemandStatus.PLANIFIE]: 'circleCheck',
  [EnumDemandStatus.ENVOYE]: 'emailActionSend',
}
